import moment from "moment";

// Rules of the live SOS alert: the website asks the API about every 15 s for SOS raised after the last one it saw.

/** How often the open website checks for a new SOS (a hidden tab is slowed down by the browser). */
export const POLL_MS = 15000;
/** Session key of the last SOS id this tab has seen (a page refresh does not alert old SOS again). */
export const LAST_ID_KEY = "sos_lastId";
/** Window event fired with the new SOS: pages showing SOS lists reload. */
export const SOS_EVENT = "sos-alert-new";
/** At most this many SOS stay in the popup. */
export const MAX_ALERTS = 20;

/** Adds new SOS to the popup list: no duplicates, newest first, at most MAX_ALERTS. */
export function mergeSos(current, incoming) {
  const byId = new Map();
  [...(incoming ?? []), ...(current ?? [])].forEach((a) => {
    if (a && !byId.has(a.id)) byId.set(a.id, a);
  });
  return [...byId.values()].sort((a, b) => b.id - a.id).slice(0, MAX_ALERTS);
}

/** Blinking tab title: "⚠ SOS (2)". */
export const sosTabTitle = (count) => `⚠ SOS (${count})`;

/** "14:32" (today) or "31 Oct, 14:32" of a UTC ISO time; "" when empty. */
export function sosTime(iso, now = moment()) {
  if (!iso) return "";
  const t = moment.utc(iso).local();
  return t.isSame(now, "day") ? t.format("HH:mm") : t.format("DD MMM, HH:mm");
}

/**
 * The SOS alarm in Morse (· · · — — — · · ·): tone start times and lengths in ms from the start of one round; a round
 * is repeated every ALARM_REPEAT_MS until it is stopped.
 */
const DOT = 150;
const DASH = 450;
const GAP = 120;
const LETTER_GAP = 360;
export const ALARM_REPEAT_MS = 4000;
export function sosTones() {
  const letters = [
    [DOT, DOT, DOT],
    [DASH, DASH, DASH],
    [DOT, DOT, DOT],
  ];
  const tones = [];
  let at = 0;
  letters.forEach((letter, i) => {
    letter.forEach((length, j) => {
      tones.push({ at, length });
      at += length + (j < letter.length - 1 ? GAP : 0);
    });
    if (i < letters.length - 1) at += LETTER_GAP;
  });
  return tones;
}
